import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class FuncaoPontoControleLookup extends React.Component {
  static defaultProps = {
    clearable: false,
  };

  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/FuncaoPontoControleLookup" clearable={true} {...this.props} />;
  }
}

export default FuncaoPontoControleLookup;
